<div class="p-g dashboard-map-container">
  <div id="tripMap" class="map"></div>

</div>
